import React from 'react';
import styled from 'styled-components';
import { Flex } from 'antd';
import { CheckCircleOutlined, CheckCircleFilled } from '@ant-design/icons';
import { useTranslation } from '@packages/utils';
import { stepOneKey } from '../../../../RegistrationModal/RegistrationModal.data';

interface PartInfoProps {
  partType: string;
  dateTimeString: string | null;
  isPassed: boolean;
  showPartLabel?: boolean;
}

const StyledFlex = styled(Flex)<{ $isPassed: boolean }>`
  border: 1px solid #dedede;
  background: ${props => (props.$isPassed ? '#F9F9F9' : '#ffffff')};
  border-radius: 8px;
  padding: 10px;

  & p {
    margin: 0;
    color: ${props => (props.$isPassed ? '#808080' : '#414042')};
  }

  & svg path {
    color: ${props => (props.$isPassed ? '#b5b5b5' : '#007B73')};
  }
`;

const PartInfo: React.FC<PartInfoProps> = ({
  partType,
  dateTimeString,
  isPassed,
  showPartLabel = true,
}) => {
  const { t } = useTranslation({
    keyPrefix: stepOneKey,
    lng: 'translate',
  });

  return (
    <StyledFlex $isPassed={isPassed} gap={10}>
      {isPassed ? <CheckCircleFilled /> : <CheckCircleOutlined />}
      {showPartLabel && <p style={{ fontWeight: 600 }}>{t(partType)}</p>}
      <p>{dateTimeString}</p>
    </StyledFlex>
  );
};

export default PartInfo;
